<script setup lang="ts">
  import { Sparkle } from 'lucide-vue-next'
  import { Button } from '@/components/ui/button'
  import { useTranslation } from '@/composables'
  import { useAiAssistantBeta } from './useAiAssistantBeta'

  const { shouldShowBanner, openModal, dismissBanner } = useAiAssistantBeta()

  const { t } = useTranslation({
    en: {
      title: 'Be the first to try JUPUS AI assistant beta',
      dismiss: 'Dismiss',
      getStarted: 'Get started'
    },
    de: {
      title: 'Sei der Erste, der die JUPUS AI Assistant Beta ausprobiert',
      dismiss: 'Ausblenden',
      getStarted: 'Jetzt starten'
    }
  })
</script>

<template>
  <div
    v-if="shouldShowBanner"
    class="flex min-h-14 w-full items-center gap-2 border-b border-[#E9D5FF] bg-[#FAF5FF] px-6 py-2"
  >
    <div class="flex flex-1 items-center gap-3">
      <div class="flex items-center justify-center rounded-full bg-[#E9D5FF] p-2">
        <Sparkle
          :stroke-width="1.5"
          class="h-5 w-5 text-[#7E22CE]"
        />
      </div>
      <div class="flex flex-1 flex-col items-start gap-1">
        <p class="self-stretch text-sm font-semibold leading-5 text-[#1F2937]">
          {{ t('title') }}
        </p>
      </div>
    </div>
    <Button
      variant="ghost"
      size="sm"
      class="text-[#1F2937]"
      @click="dismissBanner"
    >
      {{ t('dismiss') }}
    </Button>
    <Button
      size="sm"
      class="shadow-[0px_2px_4px_0px_rgba(0,0,0,0.04)]"
      @click="openModal"
    >
      {{ t('getStarted') }}
    </Button>
  </div>
</template>
